// The surfaces that list channel-less drafts. Each is filtered (server-side
// range/presence, or connection membership) so a normalized cache write by id
// can't re-evaluate whether a saved/promoted draft still belongs — refetch the
// active ones so a create/update/promote lands in (or leaves) the drafts list,
// calendar cells, and No Date sidebar.
export const DRAFT_LIST_REFETCH_QUERIES = [
  'GetContentItemList',
  'GetCalendarContentItemDrafts',
  'GetUndatedContentItemDrafts',
]
